import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { Component } from 'react';
import { getLocalText } from '@/utilities/language';
import { inputChecker } from '@/utilities/quest';
var FillinLong = /*#__PURE__*/function (_Component) {
  _inherits(FillinLong, _Component);
  function FillinLong() {
    var _getPrototypeOf2;
    var _this;
    _classCallCheck(this, FillinLong);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(FillinLong)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "validator", function (rules, answer, callback) {
      var _this$props = _this.props,
        question = _this$props.question,
        _this$props$question = _this$props.question,
        required = _this$props$question.required,
        _this$props$question$ = _this$props$question.restrictions,
        restrictions = _this$props$question$ === void 0 ? {} : _this$props$question$;
      if (required && !answer.text.trim()) {
        callback(getLocalText('SingleChoice.Selected')); // '请填写答案');
        return;
      }
      _this.checkRestrictions(answer, window.showMultiLang ? (question === null || question === void 0 ? void 0 : question["".concat(window.language, "Restrictions")]) || {} : restrictions, callback);
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "checkRestrictions", function (answer, restrictions, callback) {
      if (restrictions.openWordsRestriction === undefined && answer.text.length > 2000) {
        callback(getLocalText('LongText.placeholder')); // '字数已超2000');
        return;
      }
      if (answer.text && restrictions) {
        var checkResult = inputChecker(answer.text, restrictions);
        if (checkResult !== true) {
          callback(checkResult);
          return;
        }
      }
      callback();
    });
    return _this;
  }
  _createClass(FillinLong, [{
    key: "getTextChange",
    value: function getTextChange(text) {
      return {
        text: text,
        type: 'fillinLong'
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _question$custom,
        _this2 = this;
      var _this$props2 = this.props,
        question = _this$props2.question,
        answer = _this$props2.answer;
      var _question$restriction = question.restrictions,
        restrictions = _question$restriction === void 0 ? {} : _question$restriction;
      var _this$props$form = this.props.form,
        getFieldProps = _this$props$form.getFieldProps,
        getFieldError = _this$props$form.getFieldError;
      var id = question.id || 'unknown-form-item';
      var _question$custom$text = question.custom.text,
        text = _question$custom$text === void 0 ? '' : _question$custom$text;
      var placeholder = window.showMultiLang ? (_question$custom = question.custom) === null || _question$custom === void 0 ? void 0 : _question$custom["".concat(window.language, "Text")] : text === '内容长度请控制在2000字以内' && text !== getLocalText('LongText.placeholder') ? '' : text;
      var _ref = window.showMultiLang ? (question === null || question === void 0 ? void 0 : question["".concat(window.language, "Restrictions")]) || {} : restrictions,
        openWordsRestriction = _ref.openWordsRestriction,
        maxWords = _ref.maxWords;
      var _getFieldProps = getFieldProps(id, {
          initialValue: answer,
          rules: [{
            required: true,
            validator: this.validator
          }]
        }),
        _onChange = _getFieldProps.onChange,
        formAnswer = _getFieldProps.value;
      var error = getFieldError(id);
      if (error && error.length > 0) error = error.join(',');else error = null;
      var params = {
        error: error,
        formAnswer: formAnswer,
        placeholder: placeholder,
        onChange: function onChange(val) {
          return _onChange(_this2.getTextChange(val));
        },
        maxWords: openWordsRestriction && maxWords
      };
      return this.props.children(params);
    }
  }]);
  return FillinLong;
}(Component);
_defineProperty(FillinLong, "defaultProps", {
  answer: {
    text: '',
    type: 'fillinLong'
  }
});
export { FillinLong as default };